import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { RootState } from '../types';
import { Project, ProjectStore, UserInfo } from '@/types';
import updateProjectStore from '@/functions/updateProjectStore';
import StorableElementValues from '@/store/dataTransfertObject/StorableElementValues';

export interface AppState {
	loaded: boolean;
	logged: boolean;
	user: UserInfo | null;
	loggedAt: Date | null;
	projectStores: ProjectStore[];
	currentProject: Project | null;
	projectCount: number | null;
}

const state: AppState = {
	/** Is the application loaded */
	loaded: false,
	logged: false,
	user: null,
	loggedAt: null,
	projectStores: [],
	currentProject: null,
	projectCount: null
};

const actions: ActionTree<AppState, RootState> = {
	updateLoaded({ commit }, loaded) {
		commit('UPDATE_LOADED', loaded);
	},
	updateLogged({ commit }, logged) {
		commit('UPDATE_LOGGED', logged);
	},
	updateUser({ commit }, user) {
		commit('UPDATE_USER', user);
	},
	updateLoggedAt({ commit }, loggedAt) {
		commit('UPDATE_LOGGED_AT', loggedAt);
	},
	updateProject({ commit }, projectStores) {
		commit('UPDATE_PROJECT', projectStores);
	},
	deleteProject({ commit }, projectStores) {
		commit('DELETE_PROJECT', projectStores);
	},
	updateCurrentProject({ commit }, currentProject) {
		commit('UPDATE_CURRENT_PROJECT', currentProject);
	},
	deleteCurrentProject({ commit }, currentProject) {
		commit('DELETE_CURRENT_PROJECT', currentProject);
	},
	updateProjectCount({ commit }, projectCount) {
		commit('UPDATE_PROJECT_COUNT', projectCount);
	},
	deleteProjectCount({ commit }, projectCount) {
		commit('DELETE_PROJECT_COUNT', projectCount);
	}
};

const mutations: MutationTree<AppState> = {
	UPDATE_LOADED(state, loaded: boolean) {
		state.loaded = loaded;
	},
	UPDATE_LOGGED(state, logged: boolean) {
		state.logged = logged;
	},
	UPDATE_USER(state, user: UserInfo) {
		state.user = user;
	},
	UPDATE_LOGGED_AT(state, loggedAt: Date) {
		state.loggedAt = loggedAt;
	},
	UPDATE_PROJECT(state, storableElementValues: StorableElementValues) {
		updateProjectStore(state.projectStores, storableElementValues);
	},
	DELETE_PROJECT(state) {
		state.projectStores = [];
	},
	UPDATE_CURRENT_PROJECT(state, currentProject: Project) {
		state.currentProject = currentProject;
	},
	DELETE_CURRENT_PROJECT(state) {
		state.currentProject = null;
	},
	UPDATE_PROJECT_COUNT(state, projectCount: number) {
		state.projectCount = projectCount;
	},
	DELETE_PROJECT_COUNT(state) {
		state.projectCount = null;
	}
};

const getters: GetterTree<AppState, RootState> = {};

const appState: Module<AppState, RootState> = {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};

export default appState;
